import { useContext } from "react";
import { ProfileComponent } from "./component";
import { BgwContext } from "../../contexts/backend_gateway/context";
import {
  useGetMyOrganizationQuery,
  useWhoAmIQuery,
} from "../../services/backend_gateway/__generated__/backend_gateway-types";
import { AlertsContext } from "../../contexts/alerts/context";
import { AlertType } from "../../contexts/alerts/type";
import { signOut } from "aws-amplify/auth";

export const ProfileContainer = () => {
  const { bgwService } = useContext(BgwContext);
  const { addAlert } = useContext(AlertsContext);
  const { data: whoAmIData, loading: whoAmILoading } = useWhoAmIQuery({
    client: bgwService.getClient(),
    onError: (error) => {
      if (error?.message !== undefined) {
        addAlert({
          text: error.message!,
          type: AlertType.WARNING,
        });
      }
    },
  });

  const { data: organizationData, loading: organizationLoading } =
    useGetMyOrganizationQuery({
      client: bgwService.getClient(),
      onError: (error) => {
        if (error?.message !== undefined) {
          addAlert({
            text: error.message!,
            type: AlertType.WARNING,
          });
        }
      },
    });

  // Signout function using Amplify
  const handleSignOut = async () => {
    try {
      await signOut();
      // Amplify will handle the redirect to the hosted UI logout page
      // and then redirect back to the configured redirectSignOut URL
    } catch (error) {
      console.error("Error during signout:", error);
      addAlert({
        text: "Error during sign out. Please try again.",
        type: AlertType.WARNING,
      });
    }
  };

  return (
    <ProfileComponent
      loading={whoAmILoading || organizationLoading}
      user={whoAmIData?.whoAmI || null}
      organization={organizationData?.getMyOrganization || null}
      signOut={handleSignOut}
    />
  );
};
